import slide1 from '../../../assets/home/slide1-home.jpg';
import slide2 from '../../../assets/home/slide-home2.jpg';
import slide3 from '../../../assets/home/slide-home3.jpg';
import slide4 from '../../../assets/home/slide-home4.jpg';
import SlideDetail from "./SlideDetail";
import Carousel from 'react-material-ui-carousel'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const slideText = [
    {title: 'Préstamos para el Agro', subTitle: 'Texto descriptivo de linea o producto'},
    {title: 'Apertura de cuentas Pymes', subTitle: 'Texto descriptivo de linea o producto'},
    {title: 'Créditos para capital de trabajo', subTitle: 'Texto descriptivo de linea o producto'},
    {title: 'Cambio de cheques', subTitle: 'Texto descriptivo de linea o producto'},
]

const ImageSlider = () => {

    return (
        <Carousel
            fullHeightHover={false}
            NextIcon={<ArrowForwardIosIcon/>}
            PrevIcon={<ArrowBackIosNewIcon/>}
            navButtonsAlwaysVisible
        >
            {
                [slide1, slide2, slide3, slide4].map((slide, idx) => 
                    <SlideDetail title={slideText[idx].title}
                                 subTitle={slideText[idx].subTitle}
                                 src={slide}
                                 key={idx}
                    />
                )
            }
        </Carousel>
    )
}


export default ImageSlider